import type { Step } from '@shared/schemas';

interface Props {
  steps: Step[];
}

export default function StepList({ steps }: Props) {
  if (steps.length === 0) {
    return <p className="text-sm text-text-muted">Zatím žádný postup.</p>;
  }
  return (
    <div className="space-y-3">
      <h2 className="font-serif text-xl">Postup</h2>
      <ol className="space-y-3">
        {steps.map((step, idx) => (
          <li
            key={idx}
            className="flex gap-4 rounded-2xl border border-border bg-surface p-4 shadow-card"
          >
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent text-sm font-semibold text-white">
              {idx + 1}
            </span>
            <p className="whitespace-pre-wrap text-[15px] leading-relaxed">{step.text}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}
